import { render, staticRenderFns } from "./KnowledgeBasePanel.vue?vue&type=template&id=0a9e342c&scoped=true&"
import script from "./KnowledgeBasePanel.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBasePanel.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeBasePanel.vue?vue&type=style&index=0&id=0a9e342c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9e342c",
  null
  
)

export default component.exports